import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { getEndcustomerArticleByEndcustomerArticleID } from "API/swesum";
import EndcustomerArticleCard from "./endcustomerarticlecard/EndcustomerArticleCard";
import { useAccountCharts } from "Context/AccountCharts";

export default function EndcustomerArticle() {
  const [endcustomerArticle, setEndcustomerArticle] = useState(null);
  const { articleID } = useParams();

  useEffect(() => {
    const asyncFetchEndcustomerArticle = async () => {
      const endcustomerArticle =
        await getEndcustomerArticleByEndcustomerArticleID(articleID);
      setEndcustomerArticle(endcustomerArticle);
    };
    asyncFetchEndcustomerArticle();
  }, [articleID]);

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, p: 3 }}>
          <Typography variant="h5" gutterBottom>
            {`Slutkundsartikel -`} {endcustomerArticle?.Id}
          </Typography>

          {endcustomerArticle ? (
            <EndcustomerArticleCard endcustomerArticle={endcustomerArticle} />
          ) : null}
        </Box>
      </Box>
      {/* </Drawer> */}
    </>
  );
}
